<template>
	<FootprintTable />
</template>

<script>
import FootprintTable from '@/components/FootprintTable/FootprintTable'

export default {
	name: "FootprintPage",
	components: {
		FootprintTable
	},
	data() {
		return {
			footprints: []
		}
	}
}
</script>

<style scoped>

</style>